// extracted by mini-css-extract-plugin
module.exports = {"dialog":"DeleteGroupWithPermissionsModal_dialog__3wYO_"};